import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const AISection = () => {
  const steps = [
    { title: "AI Curiosity Lab", range: "Classes 5-7", desc: "Stories & simple activities introducing data & patterns." },
    { title: "AI Foundations", range: "Classes 8-10", desc: "Datasets, models, and everyday AI applications." },
    { title: "Applied AI Projects", range: "Classes 11-12", desc: "Build chatbots and mini-apps with guided support." },
  ];

  return (
    <section id="ai" className="py-24 bg-slate-900 relative overflow-hidden">
      {/* Abstract AI Nodes Background */}
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
           <circle cx="10" cy="20" r="1" fill="white" />
           <circle cx="90" cy="80" r="1" fill="white" />
           <circle cx="50" cy="50" r="1" fill="white" />
           <line x1="10" y1="20" x2="50" y2="50" stroke="white" strokeWidth="0.2" />
           <line x1="50" y1="50" x2="90" y2="80" stroke="white" strokeWidth="0.2" />
        </svg>
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-100 mb-4">AI Courses for the Next Generation</h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            Age-appropriate AI paths for students who want to understand the technology they use every day.
          </p>
        </div>

        <div className="relative">
          {/* Connecting Line */}
          <div className="hidden md:block absolute top-[2.5rem] left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-cyan-900 via-cyan-500 to-cyan-900 opacity-30"></div>

          <div className="grid md:grid-cols-3 gap-8">
            {steps.map((step, idx) => (
              <div key={idx} className="relative flex flex-col items-center text-center group">
                 <div className="w-20 h-20 bg-slate-800 rounded-full border-2 border-slate-700 group-hover:border-cyan-400 flex items-center justify-center mb-6 z-10 transition-colors shadow-lg shadow-black/50">
                    <span className="text-2xl font-bold text-slate-300 group-hover:text-cyan-400">{idx + 1}</span>
                 </div>
                 <h3 className="text-xl font-bold text-slate-100 mb-2">{step.title}</h3>
                 <span className="text-xs font-semibold text-cyan-500 uppercase tracking-wide mb-3 block">{step.range}</span>
                 <p className="text-slate-400 text-sm max-w-xs">{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-center mt-12">
          <p className="text-slate-500 text-sm">No prior AI experience required. Just curiosity.</p>
        </div>
      </div>
    </section>
  );
};

export default AISection;